export default __webpack_public_path__ + "static/media/noun_Battery_-3.a3fd9ca8.svg";